// extracted by mini-css-extract-plugin
module.exports = {"componentsMapCard":"styles_componentsMapCard__2qTcy","merchantName":"styles_merchantName__1lQd9"};